import * as Sentry from "@sentry/react";
import {useMemo} from "react";


function sleep(ms) {
    return new Promise(res => setTimeout(res, ms));
}


export async function withRetries(fn, {
    retries = 3,
    baseDelay = 600,
    factor = 2,
    shouldRetry = (err) => true
} = {}) {
    let attempt = 0;
    while (true) {
        try {
            return await fn(attempt);
        } catch (err) {
            attempt++;
            if (attempt > retries || !shouldRetry(err)) {
                throw err;
            }
            const delay = baseDelay * Math.pow(factor, attempt - 1);
            await sleep(delay);
        }
    }
}

export const reportSentryError = (err, context = {}) => {
    if (!err) return;

    const msg = err.message || String(err);

    // Don't spam Sentry with expected/user errors
    if (
        /network connection lost/i.test(msg) ||
        /network error/i.test(msg) ||
        /failed to fetch/i.test(msg) ||
        /load failed/i.test(msg) ||
        /login failed/i.test(msg) ||

        /aborted/i.test(msg) ||
        /PIN must be 4 digits/i.test(msg) ||
        /Enter job & 4-digit pin/i.test(msg) ||
        /Please enter a project ID/i.test(msg)
    ) {
        return;
    }

    Sentry.captureException(err, {
        extra: {
            ...context,
            message: msg
        }
    });
};

export function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export const cls = classNames


export const formatEta = (seconds) => {
    if (seconds == null) return '';
    // if (seconds < 5) return 'Finishing up';
    if (seconds < 60) return `${Math.round(seconds)}s remaining`;
    const mins = Math.round(seconds / 60);
    if (mins < 60) return `${mins} min${mins !== 1 ? 's' : ''} remaining`;
    const hours = Math.round(mins / 60);
    return `${hours} hr${hours !== 1 ? 's' : ''} remaining`;
};

export const formatSpeed = (bytesPerSec) => {
    if (!bytesPerSec || !isFinite(bytesPerSec)) return '';
    const mb = bytesPerSec / (1024 * 1024);
    if (mb < 1) {
        const kb = bytesPerSec / 1024;
        return `${kb.toFixed(0)} KB/s`;
    }
    return `${mb.toFixed(1)} MB/s`;
};